import { makeDefaultDateRange } from '@/utils/date';

const [startDateStr, endDateStr] = makeDefaultDateRange();
const queryStringWithDefaultDates = `start_date=${startDateStr}&end_date=${endDateStr}`;

// QueryStringsStore caches the URL query string, ie. "foo=bar&baz=qux", for a
// given pathname. This is used as "memory" for query strings when navigating
// back to an earlier page.

export default {
  namespaced: true,
  state: {
    '/analytics': queryStringWithDefaultDates,
    '/documents': `${queryStringWithDefaultDates}&order=-created_at`,
  },
  mutations: {
    cacheQueryStringForPath(state, { pathname, queryString }) {
      if (!pathname) {
        return;
      }
      state[pathname] = queryString ?? '';
    },
  },
  getters: {
    getCachedQueryStringForPath: (state) => (pathname) => {
      return state[pathname];
    },
  },
};
